/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any -- Disable all rules issued from linter */
import { type ClipboardInputTransformationData, ClipboardPipeline, Plugin } from 'ckeditor5';

const findRecursiveWrongImage = (parent: any) => {
  if (parent.getChildren) {
    for (const element of parent.getChildren()) {
      if (element.name === 'img' && parent.name !== 'figure') {
        return true;
      }

      if (findRecursiveWrongImage(element)) {
        return true;
      }
    }
  }

  return false;
};

export class ClipboardImageValidator extends Plugin {
  static get requires() {
    return [ClipboardPipeline];
  }

  init() {
    const { editor } = this;
    const onError = editor.config.get('clipboardImageValidator.onError');

    const clipboardPipeline = editor.plugins.get('ClipboardPipeline');
    clipboardPipeline.on('inputTransformation', (event_, data: ClipboardInputTransformationData) => {
      const { content } = data;

      if (findRecursiveWrongImage(content)) {
        event_.stop();
        onError?.('sourceValidationFailed');
      }
    });
  }
}

/* eslint-enable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any -- Disable all rules issued from linter */
